/*
 * @Description:
 * @Date: 2022-04-14 22:43:38
 * @LastEditTime: 2022-04-14 22:44:40
 */
import type { RouteLocationNormalized, Router } from 'vue-router'
import type {
  PopupRequest,
  PublicClientApplication,
  RedirectRequest,
} from '@azure/msal-browser'

import { InteractionType } from '@azure/msal-browser'

import { msalInstance, loginRequest, signupRequest } from '../../utils/auth/authConfig'
import { ElMessage } from 'element-plus'

export function routerGuard(router: Router): void {
  balloonMessageGuard(router)
  registerGuard(router)
}

function balloonMessageGuard(router: Router): void {
  router.beforeEach(() => ElMessage.closeAll())
}

export function registerGuard(router: Router) {
  router.beforeEach(
    async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
      if (to.meta.requiresAuth) {
        const requestType =
          sessionStorage.getItem('fromLoginOrSignUp') === 'SignUp'
            ? signupRequest
            : loginRequest
        const request = {
          ...requestType,
          redirectStartPage: to.fullPath,
        }

        const shouldProceed = await isAuthenticated(
          msalInstance,
          InteractionType.Redirect,
          request
        )

        return shouldProceed
      }

      return true
    }
  )
}

export async function isAuthenticated(
  instance: PublicClientApplication,
  interactionType: InteractionType,
  loginRequest: PopupRequest | RedirectRequest
): Promise<boolean> {
  // If your application uses redirects for interaction, handleRedirectPromise must be called and awaited on each page load before determining if a user is signed in or not
  return instance
    .handleRedirectPromise()
    .then(() => {
      const accounts = instance.getAllAccounts()
      if (accounts.length > 0) {
        return true
      }

      // User is not signed in and attempting to access protected route. Sign them in.
      if (interactionType === InteractionType.Popup) {
        return instance
          .loginPopup(loginRequest)
          .then(() => {
            return true
          })
          .catch(() => {
            return false
          })
      } else if (interactionType === InteractionType.Redirect) {
        return instance
          .loginRedirect(loginRequest)
          .then(() => {
            return true
          })
          .catch(() => {
            return false
          })
      }

      return false
    })
    .catch(() => {
      return false
    })
}
